module.exports = __webpack_public_path__ + "img/posterBg2-2.3feb4e10.png";